import { FaqJsonLd } from '../../seo/jsonLD/Faq';
import { ServiceJsonLd } from '../../seo/jsonLD/Services';
import { PriceSpecificationJsonLd } from '../../seo/jsonLD/PriceSpecification';
import getRichTextSummary from '../../RichText/getRichTextSummary';
import { AccordionType } from './type';
import { SchemaIds } from '../../seo/jsonLD/prepIds';

export const renderSeo = (data: AccordionType, ids: SchemaIds) => {
  const { schemaType, seoDescriptionOverride } = data.seo;

  switch (schemaType) {
    case 'FAQPage':
      return (
        <FaqJsonLd
          ids={ids}
          title={getRichTextSummary(data.titles.title)}
          overrideJson={seoDescriptionOverride}
          faqs={data.elements.map((el) => ({
            question: getRichTextSummary(el.title) || '',
            answer: getRichTextSummary(el.description),
          }))}
        />
      );
    case 'Service':
      return (
        <ServiceJsonLd
          ids={ids}
          overrideJson={seoDescriptionOverride}
          services={data.elements.map((el) => ({
            name: getRichTextSummary(el.title) || '',
            description: getRichTextSummary(el.description),
          }))}
        />
      );
    case 'PriceSpecification':
      return (
        <PriceSpecificationJsonLd
          ids={ids}
          overrideJson={seoDescriptionOverride}
          prices={data.elements.map((el) => ({
            name: getRichTextSummary(el.title) || '',
            description: getRichTextSummary(el.description),
          }))}
        />
      );
    default:
      return null;
  }
};
